<template>
	<v-row>
		<v-col cols="12" :md="12 / items.length" v-for="item in items" :key="item">
			<v-card
				class="d-flex align-center"
				active-class="primary"
				dark
				outlined
				color="rgba(0,0,255,0.1)"
				height="100"
				:to="item"
			>
				<div
					class="display-3 flex-grow-1 text-center"
					style="font-size: 0.8em"
					v-text="item"
				/>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'FileCollectionSelector',
	props: {
		items: Array,
	},
	methods: {
		isActive(title) {
			return this.$route.params.collection == title
		},
	},
}
</script>

<style lang="scss" scoped>
</style>